import {useEffect, useState} from 'react';
import {radarApi} from './radarApi';
import type {RadarOutcomeUsage} from './radarUsageModel';

/** Refresh independently of the search bundle: outreach and Watch also settle usage. */
export function useRadarUsage(token:string|undefined, workspaceId:string|undefined, initial?:RadarOutcomeUsage|null) {
  const [snapshot,setSnapshot]=useState<{token:string;workspaceId:string;initial:RadarOutcomeUsage;
    outcome:RadarOutcomeUsage;refreshFailed:boolean}|null>(null);
  useEffect(()=>{
    if(!token || !workspaceId || !initial)return;
    let cancelled=false, running=false;
    let timer:ReturnType<typeof setTimeout>;
    const refresh=async()=>{
      clearTimeout(timer);
      if(cancelled || running)return;
      if(document.visibilityState==='hidden'){timer=setTimeout(refresh,10000);return;}
      running=true;
      try {
        const outcome=await radarApi.usage(token,workspaceId);
        if(!outcome)throw new Error('Usage unavailable');
        if(!cancelled)setSnapshot({token,workspaceId,initial,outcome,refreshFailed:false});
      } catch {
        if(!cancelled)setSnapshot(previous=>({token,workspaceId,initial,
          outcome:previous?.token===token && previous.workspaceId===workspaceId && previous.initial===initial ? previous.outcome : initial,
          refreshFailed:true}));
      } finally {
        running=false;
        if(!cancelled)timer=setTimeout(refresh,10000);
      }
    };
    timer=setTimeout(refresh,10000);
    window.addEventListener('focus',refresh);
    document.addEventListener('visibilitychange',refresh);
    return ()=>{cancelled=true;clearTimeout(timer);window.removeEventListener('focus',refresh);document.removeEventListener('visibilitychange',refresh);};
  },[token,workspaceId,initial]);
  const current=snapshot?.token===token && snapshot?.workspaceId===workspaceId && snapshot?.initial===initial ? snapshot : null;
  return {outcome:current?.outcome??initial,refreshFailed:current?.refreshFailed??false};
}
